
import { defineComponent, onMounted, watch } from 'vue'
import LeftMenu from '../components/index/leftNav.vue'
import { MainModule } from '@/store/modules/main.store'
import { useRoute } from 'vue-router';

export default defineComponent({
  components: {
      LeftMenu
  },
  setup () {
    const route = useRoute();
    onMounted(() => {
        MainModule.init((route.params as any).id);
    });
    watch(route, (v: any) => {
      MainModule.changeView((v.params as any).id);
    })

    return {
    }
  }
})
